import { apiSlice } from './apiSlice';

export type DocumentRegistryRow = {
  id: number;
  catalogCode?: string | null;
  legacyType?: string | null;
  ownerScope?: string | null;
  sourceParty?: string | null;
  lifecycleState?: string | null;
  isRequired?: boolean;
  financeImpact?: string[];
  taskImpact?: string[];
  documentEngine?: {
    id: number | null;
    catalogCode: string | null;
    legacyType: string | null;
    ownerScope: string | null;
    sourceParty: string | null;
    applicationId: number | null;
    routeId: number | null;
    stopId: number | null;
    lifecycleState: string;
    isRequired: boolean;
    financeImpact: string[];
    taskImpact: string[];
  };
  documentType: string;
  /** Optional registry number; older read responses may omit it. */
  documentNumber?: string | null;
  customDocumentName?: string | null;
  customDocumentCategory?: string | null;
  typeLabel: string;
  category: string;
  fileType?: string | null;
  stage?: string | null;
  comment?: string | null;
  createdAt: string;
  fileName: string;
  sourceLabel: string;
  application: {
    id: number;
    internalNumber: string;
    externalNumber: string;
    clientName: string | null;
  } | null;
  route: {
    id: number;
    label: string | null;
    carrierId: number | null;
    carrierName: string | null;
  } | null;
  downloadCount?: number;
  lastDownloadedAt?: string | null;
};

export type DocumentRegistryListParams = {
  page?: number;
  limit?: number;
  sortBy?: 'createdAt' | 'documentType' | 'internalNumber';
  sortOrder?: 'asc' | 'desc';
  internalNumber?: string;
  applicationId?: number;
  clientId?: number;
  carrierId?: number;
  routeId?: number;
  documentCategory?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
};

export type DocumentRegistryListResponse = {
  documents: DocumentRegistryRow[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
};

export const documentRegistryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentsRegistry: builder.query<DocumentRegistryListResponse, DocumentRegistryListParams>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            searchParams.append(key, String(value));
          }
        });
        return `/documents-read/list?${searchParams.toString()}`;
      },
      transformResponse: (response: { data?: DocumentRegistryListResponse }) =>
        response.data ?? { documents: [], pagination: { page: 1, limit: 50, total: 0, pages: 0 } },
      providesTags: ['Document'],
    }),
  }),
});

export const {
  useGetDocumentsRegistryQuery,
  useLazyGetDocumentsRegistryQuery,
} = documentRegistryApi;

/** @deprecated Prefer `features/closingPackage` — kept for ClosingPackageBlock compatibility. */
export { useGetClosingPackageProjectionQuery } from '../../features/closingPackage/api/closingPackageApi';
